import React from 'react';
import { Form, Input, Select, Col, Row, InputNumber, message, Button, Popconfirm, Tooltip } from 'antd';
import Cookies from 'js-cookie';
import ModalDom from '../../../../components/Modal';
import DetailTitle from '../../../../components/DetailTitle';
import { CustomRow, CustomCol } from '../../../../components/Custom';
import { post, config, postFrom } from '../../../../axios';
import { dicBuildingStatus } from '../../../../axios/dictionaries';
import province from '../../../../area/province.json';
import city from '../../../../area/city.json';
import area from '../../../../area/area.json';
import {handleExportParams} from "../../../../utils";

const Option = Select.Option;
let filterCity = [];
let filterArea = [];

class Page extends React.Component {
    constructor() {
        super();
        this.state = {
            loading: false,
            title: "新增小区/楼栋",
            data: {
                houseLayout: []
            },
        }
    }

    render() {
        let { visible, form: { getFieldDecorator, setFieldsValue } } = this.props;
        let {
            loading,
            title,
            data,
        } = this.state;

        return <ModalDom
            title={title}
            visible={visible}
            loading={loading}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
        >
            <div className="custom">
                <Form
                    labelCol={{ span: 0 }}
                    wrapperCol={{ span: 24 }}
                >
                    {getFieldDecorator('id', {
                        initialValue: data.id
                    })(
                        <Input type={'hidden'} />
                    )}
                    <Row>
                        <Col span={24}>
                            <CustomRow>
                                <CustomCol label="楼栋编码">
                                    {getFieldDecorator('buildingNo', {
                                        rules: [{
                                            required: true, message: '请输入19位楼栋编码',
                                        }],
                                        initialValue: data.buildingNo
                                    })(
                                        <Input
                                            placeholder={'请输入19位楼栋编码'}
                                            autoComplete={'off'}
                                            minLength={19}
                                            maxLength={19}
                                        />
                                    )}
                                </CustomCol>
                                <CustomCol label="名称">
                                    {getFieldDecorator('name', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.name
                                    })(
                                        <Input
                                            placeholder={'请输入'}
                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>

                            </CustomRow>
                            <CustomRow divider>
                                <CustomCol label="省份">
                                    {getFieldDecorator('province', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.province || '广东省'
                                    })(
                                        <Select
                                            showSearch
                                            placeholder="请选择"
                                            optionFilterProp={'children'}
                                            onChange={(value) => {
                                                setFieldsValue({ city: undefined, area: undefined });
                                                let p = province.find(item => item.name === value);
                                                if (p) {
                                                    filterCity = city.filter((item, index) => item.provinceCode === p.code);
                                                }
                                                filterArea = [];
                                                this.forceUpdate();
                                            }}
                                        >
                                            {province.map((item, index) => <Option title={item.name} value={item.name} key={index}>{item.name}</Option>)}
                                        </Select>
                                    )}
                                </CustomCol>
                                <CustomCol label="城市">
                                    {getFieldDecorator('city', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.city || '深圳市'
                                    })(
                                        <Select
                                            showSearch
                                            placeholder="请选择"
                                            optionFilterProp={'children'}
                                            onChange={(value) => {
                                                setFieldsValue({ area: undefined });
                                                let c = city.find(item => item.name === value);
                                                if (c) {
                                                    filterArea = area.filter((item, index) => item.cityCode === c.code);
                                                }
                                                this.forceUpdate();
                                            }}
                                        >
                                            {filterCity.map((item, index) => <Option title={item.name} value={item.name} key={index}>{item.name}</Option>)}
                                        </Select>
                                    )}
                                </CustomCol>
                                <CustomCol label="区域">
                                    {getFieldDecorator('area', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.area
                                    })(
                                        <Select
                                            showSearch
                                            placeholder="请选择"
                                            optionFilterProp={'children'}
                                        >
                                            {filterArea.map((item, index) => <Option title={item.name} value={item.name} key={index}>{item.name}</Option>)}
                                        </Select>
                                    )}
                                </CustomCol>
                            </CustomRow>
                            <CustomRow divider>
                                <CustomCol label="详细地址" colStyle={{ width: '500px' }}>
                                    {getFieldDecorator('address', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.address
                                    })(
                                        <Input
                                            placeholder={'请输入'}
                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>
                            </CustomRow>
                            <CustomRow divider>
                                <CustomCol label="层高">
                                    {getFieldDecorator('floorCount', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.floorCount
                                    })(
                                        <InputNumber
                                            placeholder={'请输入'}
                                            autoComplete={'off'}
                                            max={99}
                                            min={0}
                                        />
                                    )}
                                </CustomCol>
                                <CustomCol label="状态">
                                    {getFieldDecorator('status', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.status || 1
                                    })(
                                        <Select
                                            showSearch
                                            placeholder="请选择状态"
                                            optionFilterProp={'children'}
                                        >
                                            {dicBuildingStatus.map((item, index) => <Option value={item.value} key={item.value}>{item.title}</Option>)}
                                        </Select>
                                    )}
                                </CustomCol>
                            </CustomRow>
                            {
                                this.isNotJr() &&
                                <DetailTitle title="房型"/>
                            }
                            {
                                this.isNotJr() &&
                                data.houseLayout instanceof Array
                                ? data.houseLayout.map((item, index) => {
                                return <CustomRow key={item.key}>
                                <CustomCol label="室">
                                {getFieldDecorator(`f${item.key}`, {
                                    rules: [{
                                        required: true, message: '请输入',
                                    }],
                                    initialValue: item.f
                                })(
                                    <InputNumber
                                        placeholder={'请输入'}
                                        min={0}
                                    />
                                )}
                                </CustomCol>
                                <CustomCol label="厅">
                                {getFieldDecorator(`t${item.key}`, {
                                    rules: [{
                                        required: true, message: '请输入',
                                    }],
                                    initialValue: item.t
                                })(
                                    <InputNumber
                                        placeholder={'请输入'}
                                        min={0}
                                    />
                                )}
                                </CustomCol>
                                <CustomCol label="卫">
                                {getFieldDecorator(`w${item.key}`, {
                                    rules: [{
                                        required: true, message: '请输入',
                                    }],
                                    initialValue: item.w
                                })(
                                    <InputNumber
                                        placeholder={'请输入'}
                                        min={0}
                                    />
                                )}
                                </CustomCol>
                                <div style={{display: 'flex', justifyContent: 'center', padding: '5px 0'}}>
                                <Popconfirm
                                placement="topRight"
                                title={'此删除操作不可恢复，确定删除吗？'}
                                onConfirm={() => {
                                this.handleMinus(index)
                            }}
                                okText="删除"
                                cancelText="取消"
                                >
                                <Button style={{
                                marginLeft: '26px',
                                width: '24px',
                                height: '24px'
                            }} shape="circle" icon="minus" />
                                </Popconfirm>
                                </div>
                                </CustomRow>
                            })
                                : null

                            }
                            {
                                this.isNotJr() &&
                                <div style={{marginTop: '20px', textAlign: 'center'}}>
                                    <Tooltip placement="bottomLeft" title={"添加一行户型输入框"}>
                                        <Button onClick={() => {
                                            this.handlePlus()
                                        }} style={{
                                            width: '40px',
                                            height: '40px',
                                            textAlign: 'center',
                                            lineHeight: '36px',
                                            fontSize: '20px'
                                        }} shape="circle" icon="plus"/>
                                    </Tooltip>
                                </div>
                            }
                        </Col>
                    </Row>
                </Form>
            </div>
        </ModalDom>
    }

    componentDidMount() {
        this.props.onRef(this);
    }

    handleMinus = (index) => { //房源户型减1
        let { data } = this.state;
        let item = data.houseLayout[index];
        if (item) {
            if (item.id) {
                this.setState({ loading: true });
                postFrom({ url: config.API_houselayout_deleteHouseLayout, data: { houseLayoutId: item.id } }).then(res => {
                    data.houseLayout.splice(index, 1);
                    this.setState({ data, loading: false });
                }).catch(err => {
                    message.error(err.message || '删除失败');
                    this.setState({ loading: false })
                });
            } else {
                data.houseLayout.splice(index, 1);
                this.setState({ data });
            }
        }
    }

    handlePlus = () => { //房源户型加1
        let { data } = this.state;
        if (data.houseLayout instanceof Array) {
            if (data.houseLayout.length) {
                data.houseLayout.push({ key: data.houseLayout[data.houseLayout.length - 1].key + 1, f: '', t: '', w: '' });
            } else {
                data.houseLayout.push({ key: 0, f: '', t: '', w: '' });
            }
        } else {
            data.houseLayout = [{ key: 0, f: '', t: '', w: '' }];
        }
        this.setState({ data });
    }

    isNotJr=()=>{
        return handleExportParams().isJr === 2
    }

    handleCancel = () => { //关闭页面
        this.props.handleCancel();
        filterCity = [];
        filterArea = [];
        this.setState({ data: {}, loading: false, title: "新增小区/楼栋" });
    }

    initPack = () => {
        filterCity = city.filter((item, index) => item.provinceCode === '44');
        filterArea = area.filter((item, index) => item.cityCode === '4403');
        this.forceUpdate();
    }

    loadPack = ({ id }) => {
        this.setState({ loading: true, title: "编辑小区/楼栋" });
        postFrom({ url: config.API_building_getBuildingById, data: { keyword: id } }).then(res => {
            res.houseLayout = res.houseLayout.map((item, index) => { //添加一个key，以便增加一栏时数据不错乱
                item.key = index;
                return item
            });

            let p = province.find(item => item.name === res.province);
            let c = city.find(item => item.name === res.city);

            filterCity = city.filter((item, index) => (item.provinceCode === res.province || (p ? p.code === item.provinceCode : false)));
            filterArea = area.filter((item, index) => (item.cityCode === res.city || (c ? c.code === item.cityCode : false)));

            this.setState({ data: res, loading: false });
        }).catch(err => {
            message.error(err.message || '获取详情失败');
            this.setState({ loading: false });
        });
    }

    handleOk = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
            if (!error) {
                let loginData = Cookies.get('loginData');
                if (loginData) {
                    loginData = JSON.parse(loginData);
                    values.merchantId = loginData.merchantId ? loginData.merchantId : 0;
                } else {
                    message.error('未登录')
                    return
                }

                let { data: { houseLayout } } = this.state;
                this.setState({ loading: true });

                let valueKeys = Object.keys(values);
                let fKeys = valueKeys.filter((item, index) => { //获取出户型字段
                    if (/^f[\d]+$/.test(item)) return item;
                });
                values.houseLayout = fKeys.map((item, index) => { //处理户型字段
                    let id = houseLayout[index].id;
                    let buildingId = houseLayout[index].buildingId;
                    let num = item.slice(1);
                    item = {
                        id: id || 0,
                        buildingId: buildingId || 0,
                        f: values[`f${num}`],
                        t: values[`t${num}`],
                        w: values[`w${num}`]
                    };
                    delete values[`f${num}`];
                    delete values[`t${num}`];
                    delete values[`w${num}`];
                    return item
                });

                if (values.id) {
                    post({ url: config.API_building_edit, data: values }).then(res => {
                        message.success('编辑成功');
                        this.props.handleGetList();
                        this.handleCancel();
                    }).catch(err => {
                        message.error(err.message || '编辑失败');
                        this.setState({ loading: false });
                    })
                } else {
                    post({ url: config.API_building_create, data: values }).then(res => {
                        message.success('新增成功');
                        this.props.handleGetList();
                        this.handleCancel();
                    }).catch(err => {
                        message.error(err.message || '新增失败');
                        this.setState({ loading: false });
                    })
                }
            }
        })
    }
}

export default Form.create()(Page);


// WEBPACK FOOTER //
// ./src/page/House/components/BuildingAdd/index.js